// extracted by mini-css-extract-plugin
module.exports = {"modalLinks":"styles_modalLinks__4I_Fd","link":"styles_link__1Knzf"};